import apiClient from './apiClient';
import { Message, ChatRoom } from '../types';

export const chatApi = {
  getChatRooms: async (): Promise<ChatRoom[]> => {
    const response = await apiClient.get<ChatRoom[]>('/chat/rooms');
    return response.data;
  },

  getMessages: async (matchId: string): Promise<Message[]> => {
    const response = await apiClient.get<Message[]>(`/chat/${matchId}/messages`);
    return response.data;
  },

  sendMessage: async (matchId: string, content: string): Promise<Message> => {
    const response = await apiClient.post<Message>(`/chat/${matchId}/messages`, {
      content,
    });
    return response.data;
  },

  markAsRead: async (matchId: string): Promise<void> => {
    await apiClient.post(`/chat/${matchId}/read`);
  },
};
